import type {
  ProjectSelectionController,
  ProjectSelectionState,
  SelectedItem,
} from "../types/ProjectSelection";

type Params = {
  state: ProjectSelectionState;
  setState: React.Dispatch<React.SetStateAction<ProjectSelectionState>>;
};

export function createProjectSelectionAdapter({
  state,
  setState,
}: Params): ProjectSelectionController {
  const setProject = (project: SelectedItem | null) => {
    setState((prev) => {
      if (!project) {
        return {
          project: null,
          phase: [],
          block: [],
          stage: [],
          category: undefined,
        };
      }

      if (prev.project?.id === project.id) {
        return {
          ...prev,
          project,
        };
      }

      return {
        project,
        phase: [],
        block: [],
        stage: [],
        category: prev.category,
      };
    });
  };

  const setPhase = (phase: SelectedItem[]) => {
    setState((prev) => ({
      ...prev,
      phase,
      block: [],
      stage: [],
    }));
  };

  const setBlock = (block: SelectedItem[]) => {
    setState((prev) => ({
      ...prev,
      block,
      stage: [],
    }));
  };

  const setStage = (stage: SelectedItem[]) => {
    setState((prev) => ({
      ...prev,
      stage,
    }));
  };

  const setCategory = (category: number | undefined) => {
    setState((prev) => ({
      ...prev,
      category,
    }));
  };

  const reset = () => {
    setState({
      project: null,
      phase: [],
      block: [],
      stage: [],
      category: undefined,
    });
  };

  return {
    state,
    setProject,
    setPhase,
    setBlock,
    setStage,
    setCategory,
    reset,

    hasProject: state.project !== null,
    hasPhase: state.phase.length > 0,
    hasBlock: state.block.length > 0,
    hasStage: state.stage.length > 0,
  };
}
